import { Flex, Form } from "antd";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { observer } from "mobx-react-lite";
import { useNotificationContext } from "providers";
import { useMemo, useState } from "react";

import { declineContractDraft } from "services";
import { useStores } from "stores";
import { CustomButton, DefaultTextArea } from "ui";
import { requestWithNotify } from "utils";
import { _isNotLongerThan, _isRequired, _isValidCommentText } from "utils/form/simple-validation";

export const CancelDraftModal = observer(() => {
  const { actionModals, contractCard } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const comment = Form.useWatch("comment", form);

  const disabled = useMemo(() => {
    return loading || !String(comment || "").trim();
  }, [loading, comment]);

  const closeModal = () => {
    actionModals.closeAll();
  };

  const onFinish = async () => {
    setLoading(true);

    const formattedComment = String(comment || "").trim();

    try {
      const res = await requestWithNotify({
        fetchFn: () => declineContractDraft({ id: contractCard.card.id }, { comment: formattedComment }),
        openNotification,
        successMsg: "Черновик договора отклонен",
      });

      if (!res.result) {
        return;
      }

      closeModal();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex vertical gap="large">
      <Form form={form} name="declineDraftContract" onFinish={onFinish}>
        <Form.Item
          name="comment"
          rules={[
            _isRequired("Укажите причину отклонения"),
            _isNotLongerThan(150, "Причина отклонения не должна быть длиннее 150 символов"),
            _isValidCommentText("Причина отклонения не должна содержать специальные символы"),
          ]}
          validateDebounce={FORM_VALIDATION_DEBOUNCE}
        >
          <DefaultTextArea placeholder="Причина отклонения..." maxLength={150} rows={4} disabled={loading} />
        </Form.Item>

        <Form.Item className="margin-none">
          <Flex gap="large">
            <CustomButton htmlType="submit" disabled={disabled} loading={loading} className="full-width">
              Подтвердить
            </CustomButton>
            <CustomButton
              htmlType="button"
              type="default"
              disabled={loading}
              loading={loading}
              onClick={closeModal}
              className="full-width"
            >
              Отмена
            </CustomButton>
          </Flex>
        </Form.Item>
      </Form>
    </Flex>
  );
});
